import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import ExpandLess from '@material-ui/icons/ExpandMore';
import ExpandMore from '@material-ui/icons/NavigateNext';
import { ReactComponent as DSLogo } from 'assets/logo-white.svg';


const drawerWidth = 220;

const styles = (theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.05)',
    backgroundColor: '#004a8c',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolBar: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '80%',
    padding: 0,
  },
  menuButton: {
    marginLeft: 12,
  },
  hide: {
    display: 'none',
  },
  sectionDesktop: {
    // display: 'none',
    // [theme.breakpoints.up('md')]: {
    //   display: 'flex',
    // },
  },
  // sectionMobile: {
  //   display: 'flex',
  //   [theme.breakpoints.up('md')]: {
  //     display: 'none',
  //   },
  // },
  grow: {
    flexGrow: 1,
  },
  profileName: {
    cursor: 'pointer',
  },
  menuItem: {
    color: theme.palette.common.black,
  },
  menuItemSmallScreen: {
    color: theme.palette.common.black,
  },
  icon: {
    color: theme.palette.common.white,
    marginRight: theme.spacing(1),
    minWidth: 0,
    fontSize: 16,
  },
  avatar: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.primary,
  },
});

class TopBar extends React.Component {
  state = {
    anchorEl: null,
  };

  handleProfileMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = (e, item) => {
    this.setState({ anchorEl: null });
    if (item.isExternal) {
      e.preventDefault();
      window.open(item.path);
    }
  };

  render() {
    const { classes, profileItems, profileName, showTabMenu } = this.props;
    const { anchorEl } = this.state;
    const isMenuOpen = Boolean(anchorEl);
    let menuIndex = -1;

    const lastName = profileName ? profileName.split(' ').slice(-1)[0] : '';
    const initial =
      (profileName ? profileName.charAt(0).toUpperCase() : '') +
      (lastName ? lastName.charAt(0).toUpperCase() : '');

    const renderMenu = (
      <Menu
        className={classes.menu}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={isMenuOpen}
        getContentAnchorEl={null}
        onClose={this.handleMenuClose}>
        {profileItems &&
          profileItems.map((item, index) => {
            menuIndex++;
            return (
              <div key={item.name}>
                {menuIndex > 0 && menuIndex % 2 === 0 && <Divider />}
                <MenuItem
                  onClick={(e) => this.handleMenuClose(e, item)}
                  key={item.name}
                  component={item.isExternal ? null : Link}
                  to={item.isExternal ? null : item.path}
                  className={classes.menuItem}>
                  {item.name}
                </MenuItem>
              </div>
            );
          })}
      </Menu>
    );

    return (
      <Fragment>
        <AppBar position="fixed" className={classNames(classes.appBar)}>
          <Toolbar className={classes.toolBar}>
            <DSLogo />
            <div className={classes.grow} />
            <div
              className={classNames({
                [classes.menuButton]: !showTabMenu,
                [classes.sectionDesktop]: showTabMenu,
              })}>
              <IconButton
                aria-owns={isMenuOpen ? 'material-appbar' : undefined}
                aria-haspopup="true"
                onClick={this.handleProfileMenuOpen}
                color="inherit">
                <Avatar className={classes.avatar}>{initial}</Avatar>
                {isMenuOpen ? (
                  <ExpandMore
                    onClick={this.handleProfileMenuOpen}
                    className={classes.icon}
                  />
                ) : (
                  <ExpandLess
                    onClick={this.handleProfileMenuOpen}
                    className={classes.icon}
                  />
                )}
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {renderMenu}
      </Fragment>
    );
  }
}

TopBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  handleDrawerOpen: PropTypes.func,
  profileItems: PropTypes.array,
  showTabMenu: PropTypes.bool,
  tabRoutes: PropTypes.array,
  selectedTab: PropTypes.number,
  handleTabChane: PropTypes.func,
};

export default withStyles(styles, { withTheme: true })(TopBar);
